<telxl-panel
    bodyClass="card-body-sm"
    cardClass="mb-2"
    [hover]="!disabled()"
    [selected]="
        selected().item.includes('card') &&
        selected().selected === true &&
        !disabled()
    "
    [highlight]="highlight() && !disabled()"
    (click)="cardSelected()"
    (keypress)="cardSelected()"
    tabindex="0"
    [ngStyle]="{
        cursor: mode().includes('card') ? 'pointer' : 'auto',
    }"
>
    <ng-template #cardBody>
        @switch (template()) {
            @case ('default') {
                <telxl-shared-directory-listing-default-item
                    [source]="source()"
                    [customButtonTemplate]="customButtonTemplate()"
                    [item]="item()"
                    [mode]="mode()"
                    [displayMediaIcons]="displayMediaIcons()"
                    [disabled]="disabled()"
                    [selected]="selected()"
                    [view]="view()"
                    (selectedChange)="selectedChange.emit($event)"
                />
            }
            @case ('internal') {
                <telxl-shared-directory-listing-internal-item
                    [source]="source()"
                    [item]="item()"
                    [mode]="mode()"
                    [disabled]="disabled()"
                    [selected]="selected()"
                    (selectedChange)="selectedChange.emit($event)"
                />
            }
            @case ('ivr') {
                <telxl-shared-directory-listing-ivr-item
                    [source]="source()"
                    [item]="item()"
                    [mode]="mode()"
                    [disabled]="disabled()"
                    [selected]="selected()"
                    (selectedChange)="selectedChange.emit($event)"
                />
            }
        }
    </ng-template>
</telxl-panel>
